import { Phone, MessageCircle, FileText } from "lucide-react";
import { PHONE_1_TEL, waLink, WA_DEFAULT, scrollToId } from "@/data/site";

export const FloatingButtons = () => (
  <>
    <a
      data-testid="whatsapp-float-btn"
      href={waLink(WA_DEFAULT)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-[80] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl group-hover:scale-110 transition-transform duration-300">
        <MessageCircle size={26} />
      </span>
    </a>

    <div data-testid="mobile-sticky-cta" className="fixed bottom-0 inset-x-0 z-[70] md:hidden grid grid-cols-3 border-t gold-hairline bg-espresso">
      <a data-testid="sticky-call-btn" href={`tel:${PHONE_1_TEL}`} className="flex flex-col items-center gap-1 py-3 text-cream/90 active:bg-espresso-light">
        <Phone size={17} className="text-gold" />
        <span className="text-[9px] tracking-[0.25em] uppercase">Call</span>
      </a>
      <a data-testid="sticky-whatsapp-btn" href={waLink(WA_DEFAULT)} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-1 py-3 text-cream/90 border-x gold-hairline active:bg-espresso-light">
        <MessageCircle size={17} className="text-[#25D366]" />
        <span className="text-[9px] tracking-[0.25em] uppercase">WhatsApp</span>
      </a>
      <button data-testid="sticky-quote-btn" onClick={() => scrollToId("quote")} className="flex flex-col items-center gap-1 py-3 text-cream/90 active:bg-espresso-light">
        <FileText size={17} className="text-gold" />
        <span className="text-[9px] tracking-[0.25em] uppercase">Get Quote</span>
      </button>
    </div>
  </>
);
